import { render, staticRenderFns } from "./NavbarMobile.vue?vue&type=template&id=4edd5752"
import script from "./NavbarMobile.vue?vue&type=script&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&lang=js"
import style0 from "./NavbarMobile.vue?vue&type=style&index=0&id=4edd5752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports